import { React, useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { auth, logInWithEmailAndPassword, signInWithGoogle, signInWithFacebook, signInWithTwitter } from "./Firebase";
import { getAuth } from "firebase/auth";
import './Login.css'
import { Google, Facebook, Twitter } from 'react-bootstrap-icons';
import { Hidden } from '@mui/material';

export default function Login() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [type, setType] = useState('password')
  function symbol(){
    setType('')
  }
  const navigate = useNavigate();
  const auth1 = getAuth();
  const user = auth1.currentUser;
  auth1.onAuthStateChanged((user)=>{
    if(user){
    navigate('/user')
    }
  })
  return (
    <div className='body-login mx-auto my-5'>
        <hr style={{color: "black", backgroundColor: "black",visibility: "hidden"}}></hr>
        <hr style={{color: "black", backgroundColor: "black",visibility: "hidden"}}></hr>
    <div className='RegLog-login my-5 padding'>
        <h3 className='padding'>Welcome</h3>
        <div className='form-login'>
            <label className='padding'>Email:</label><br></br>
            <input placeholder='Email' value={email} autoComplete='on'
             onChange={(e)=>{setEmail(e.target.value)}} required={true}></input><br></br>
            <label className='padding'>Password:</label><br></br>
            <input placeholder='Password' autoComplete='on'
            //  style={{zIndex: '-1'}}
            value={password} type={type} onChange={(e)=>{setPassword(e.target.value)}} required={true}>
            </input>
            <i className="symbol bi bi-eye " onClick={()=> symbol()}></i>
        </div>
        <button className='btn btn-login my-2' onClick={() => Login()}>Login</button>
        <div className='Auth-links padding'>
    <Google className='mx-2 ' style={{fontSize: "1.5rem"}} onClick={()=>signInWithGoogle()}></Google>
    <Facebook className='mx-2 ' style={{fontSize: "1.5rem"}} onClick={()=>signInWithFacebook()}></Facebook>
    <Twitter className='mx-2 ' style={{fontSize: "1.5rem"}} onClick={()=>signInWithTwitter()}></Twitter>
        </div>
        <Link to="/register" className='a-login padding'>Become a Member</Link>
        <Link className='a-login' to='/forgot padding'> Forgot Password? </Link>
    </div>
    </div>
  )
  function Login(){
  try{
    logInWithEmailAndPassword(email, password)
   } catch(err){
    console.log(err)
   }
}
}
